import { cx } from "../../lib/cx.js";
import { useIconSet } from "./IconProvider.js";
import { icons } from "./registry.js";
/* empty css         */
import { createElement } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Icon/Icon.tsx
/**
* A Lucide icon (24 grid, stroke 2) in the current text colour, or the brand's glyph
* for that name when an IconProvider replaces it. Decorative unless it has a `label`.
* Never focusable.
*/
function Icon({ name, size, label, tone, className, style, ...rest }) {
	const sizeStyle = size === void 0 ? void 0 : { "--_icon-size": `${size / 16}rem` };
	const a11y = label ? {
		role: "img",
		"aria-label": label
	} : { "aria-hidden": true };
	const replacement = useIconSet()[name];
	let node = icons[name];
	let glyph;
	if (replacement && "node" in replacement) {
		glyph = replacement;
		node = replacement.node;
	} else if (replacement) node = replacement;
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: glyph?.viewBox ?? "0 0 24 24",
		fill: glyph?.fill ?? "none",
		stroke: glyph?.stroke ?? "currentColor",
		strokeWidth: glyph?.strokeWidth ?? 2,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		focusable: "false",
		"data-icon": name,
		"data-icon-source": replacement ? "brand" : void 0,
		className: cx("ds-icon", tone && `ds-icon--${tone}`, className),
		style: {
			...sizeStyle,
			...style
		},
		...a11y,
		...rest,
		children: node.map(([tag, attributes], index) => createElement(tag, {
			key: index,
			...attributes
		}))
	});
}
//#endregion
export { Icon };

//# sourceMappingURL=Icon.js.map